export enum WorkbookType {
  DRAFT = 'draft', // Workbook version is in edit mode state
  READONLY = 'readonly', // Draft version was saved is saved but never published
  SHARED_DRAFT = 'shared_draft', // Like historical draft but visible to everyone
  PUBLISHED = 'published', // This is currently publish version
  DEPUBLISHED = 'depublished', // My versions was published before for this workbook
}

export const PRIVATE_DRAFT = 'private_draft'; // Display-only: draft owned by another user (not stored in backend)
